export const LOCKED_PAGE = 'LOCKED_PAGE';
